import { Deserializable } from '../../protocols/deserializable';
import { GoverningJurisdictionType } from '../../employers/employer-history/types/governing-jurisdiction-type';
import { MemberAccount } from '../../transactions/member-account';
import { MemberUser } from './member-user';
import { BaseType } from '../../base/base-type';
import { StatusPill } from '../../shared/status-pill';
import { EmployerStatusTypeEnum } from '../../employers/enum/employer-status-type.enum';
import { EmployerContact } from '../../employers/dto/employer-contact';
import { Address } from './address';
import { EmployerPlan } from '../../employers/plans/employer-plan';
import { EmployerLogo } from './employer-logo';

export class Employer implements Deserializable {
  public id!: number;
  public name!: string;
  public shortName!: string;
  public organizationCreationDate!: string;
  public entranceDate!: string;
  public craPayrollRemittanceAccountNumber!: string;
  public statusId!: number;
  public status!: BaseType;
  public typeId!: number;
  public type!: BaseType;
  public planId!: number;
  public plan!: EmployerPlan;
  public governingJurisdictionId!: number;
  public governingJurisdiction!: GoverningJurisdictionType;
  public votingRegionId!: number;
  public votingRegion!: BaseType;
  // Only Expandable if using Get Employer By ID
  public accounts!: MemberAccount[];
  public users!: MemberUser[];
  public contacts!: EmployerContact[];
  public headOfficeAddress!: Address;
  public mailingAddress!: Address;
  public logo!: EmployerLogo | null;

  // Not from API
  public statusPill!: StatusPill;

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (!!this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize?.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }
    if (!!this.accounts) {
      this.accounts = Deserialize?.arrayOf(MemberAccount, this.accounts);
    }
    if (!!this.users) {
      this.users = Deserialize?.arrayOf(MemberUser, this.users);
    }
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(BaseType, this.status);
      const primaryColor = this.statusId === EmployerStatusTypeEnum.Active ? '#0D5D4B' : '#666666';
      const secondaryColor = this.statusId === EmployerStatusTypeEnum.Active ? '#E8F3F1' : '#F7F7F7';
      this.statusPill = new StatusPill(this?.statusId, this?.status?.name, primaryColor, secondaryColor);
    }
    if (!!this.type) {
      this.type = Deserialize?.instanceOf(BaseType, this.type);
    }
    if (!!this.votingRegion) {
      this.votingRegion = Deserialize?.instanceOf(BaseType, this.votingRegion);
    }
    if (!!this.headOfficeAddress) {
      this.headOfficeAddress = Deserialize?.instanceOf(Address, this.headOfficeAddress);
    }
    if (!!this.mailingAddress) {
      this.mailingAddress = Deserialize?.instanceOf(Address, this.mailingAddress);
    }
    if (!!this.plan) {
      this.plan = Deserialize?.instanceOf(EmployerPlan, this.plan);
    }
    if (!!this.logo) {
      this.logo = Deserialize?.instanceOf(EmployerLogo, this.logo);
    }
  }
}
